import { isElectron } from '@/utils/electron/electronUtils'

export const NODE_TYPES = {
  DATASET: 'dataset',
  LABELING: 'labeling',
  TRAIN: 'train',
  VALIDATION: 'validation',
  INFERENCE: 'inference',
  IMAGE_MATCHING: 'imageMatching',
  PREPROCESSING: 'preprocessing',
  PREPROCESSING_RESULT: 'preprocessingResult',
  ROI: 'roi',
  DATA_DRIFT: 'dataDrift',
  MODEL_DRIFT: 'modelDrift',
  MODEL_PERFORMANCE: 'modelPerformance',
  MODEL_RETRAIN: 'modelRetrain',
  MODEL_RETRAIN_EVALUATION: 'modelRetrainEvaluation',
} as const

export const VALID_LINKS_BY_TYPE: { [key: string]: string[] } = !isElectron() ? {
  [NODE_TYPES.DATASET]: [NODE_TYPES.LABELING, NODE_TYPES.INFERENCE, NODE_TYPES.IMAGE_MATCHING, NODE_TYPES.PREPROCESSING, NODE_TYPES.MODEL_DRIFT],
  [NODE_TYPES.LABELING]: [NODE_TYPES.TRAIN, NODE_TYPES.VALIDATION, NODE_TYPES.ROI],
  [NODE_TYPES.TRAIN]: [NODE_TYPES.VALIDATION, NODE_TYPES.INFERENCE, NODE_TYPES.MODEL_DRIFT],
  [NODE_TYPES.IMAGE_MATCHING]: [NODE_TYPES.TRAIN, NODE_TYPES.VALIDATION],
  [NODE_TYPES.PREPROCESSING]: [NODE_TYPES.PREPROCESSING_RESULT],
  [NODE_TYPES.PREPROCESSING_RESULT]: [NODE_TYPES.LABELING, NODE_TYPES.INFERENCE, NODE_TYPES.IMAGE_MATCHING, NODE_TYPES.PREPROCESSING],
  [NODE_TYPES.ROI]: [NODE_TYPES.TRAIN, NODE_TYPES.VALIDATION],
  [NODE_TYPES.VALIDATION]: [NODE_TYPES.MODEL_PERFORMANCE],
} : {
  [NODE_TYPES.DATASET]: [NODE_TYPES.LABELING, NODE_TYPES.INFERENCE, NODE_TYPES.IMAGE_MATCHING, NODE_TYPES.PREPROCESSING],
  [NODE_TYPES.LABELING]: [NODE_TYPES.TRAIN, NODE_TYPES.VALIDATION, NODE_TYPES.ROI],
  [NODE_TYPES.TRAIN]: [NODE_TYPES.VALIDATION, NODE_TYPES.INFERENCE],
  [NODE_TYPES.IMAGE_MATCHING]: [NODE_TYPES.TRAIN, NODE_TYPES.VALIDATION],
  [NODE_TYPES.PREPROCESSING]: [NODE_TYPES.PREPROCESSING_RESULT],
  [NODE_TYPES.PREPROCESSING_RESULT]: [NODE_TYPES.LABELING, NODE_TYPES.INFERENCE, NODE_TYPES.IMAGE_MATCHING, NODE_TYPES.PREPROCESSING],
  [NODE_TYPES.ROI]: [NODE_TYPES.TRAIN, NODE_TYPES.VALIDATION],
  [NODE_TYPES.VALIDATION]: [NODE_TYPES.MODEL_PERFORMANCE],
}

export const OPS_VALID_LINKS_BY_TYPE: { [key: string]: string[] } = {
  [NODE_TYPES.DATASET]: [NODE_TYPES.LABELING],
  [NODE_TYPES.LABELING]: [NODE_TYPES.DATA_DRIFT],
}
